import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import { withQueryParams } from "../hoc/with-query-params";
import objectToQueryString from "modules/object-to-query-string";

export class GridPaginationLink extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    closeProductDrawer: PropTypes.func,
    direction: PropTypes.string,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    path: PropTypes.string.isRequired,
    queryParams: PropTypes.shape({
      sort: PropTypes.string,
      filters: PropTypes.object,
    }).isRequired,
  };

  static defaultProps = {
    direction: "next",
  };

  isPrevious = () => {
    return this.props.direction === "previous";
  };

  getClassName = () => {
    return "pagination-nav pagination-nav-" + (this.isPrevious() ? "prev" : "next");
  };

  getLabel = () => {
    return (this.isPrevious() ? "Previous" : "Next") + " page";
  };

  getQueryParams = () => {
    return _.extend({}, this.props.queryParams, { page: this.props.page });
  };

  getHref = () => {
    return this.props.path + "?" + objectToQueryString(this.getQueryParams());
  };

  changePage = event => {
    event.preventDefault();

    // To prevent a regression bug, the product drawer needs to be closed before paginating.
    if (this.props.closeProductDrawer) {
      this.props.closeProductDrawer();
    }

    this.props.onChangePage(this.getHref(), this.props.page);
  };

  render() {
    const newProps = {
      className: this.getClassName(),
      title: this.getLabel(),
    };

    if (this.props.active) {
      return (
        <a onClick={this.changePage} {...newProps} href={this.getHref()}>
          {this.getLabel()}
        </a>
      );
    } else {
      return <span {...newProps}>{this.getLabel()}</span>;
    }
  }
}

export default withQueryParams()(GridPaginationLink);
